<script lang="ts">
  export let dataLabel: string;
  export let dataPoint: number;
  export let averageDeltaPercent: number | null;
  export let dataPointAverage: number | null;
  export let subsectionLabels: string[] | null;
  export let maxValue: number;
  export let showDetails: boolean = true;
  export let isFocused: boolean;
  export let onClick: () => void;

  const getPercentage = (n: number, total: number): number =>
    Math.round((n / total) * 100);
  const getPercentageStyle = (n: number, total: number): string => {
    const percentage = getPercentage(n, total);
    return `width: ${percentage > 0 ? percentage : 1}%;`
  };
  const getPercentageMarginStyle = (n: number, total: number): string => {
    const percentage = getPercentage(n, total);
    return `margin-left: calc(${percentage > 0 ? percentage : 1}% + 25px);`;
  }
</script>

<style>
  .data-row {
    font-family: var(--theme-font-regular), sans-serif;
    height: 3.25em;
    display: flex;
    align-items: center;
  }
  .data-label-wrapper {
    display: flex;
    align-items: center;
  }
  .data-label {
    font-size: 1em;
    padding-right: 1em;
    box-sizing: border-box;
    width: 10em;
    max-height: 2.25em;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: right;
  }
  .data-bar-wrapper {
    height: 2.25em;
    box-sizing: border-box;
    width: 40%;
    display: flex;
    align-items: center;
  }
  .data-point {
    font-size: 1rem;
    box-sizing: border-box;
    min-width: 3rem;
    max-height: 2.25rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
  }
  .data-bar {
    box-sizing: border-box;
    cursor: pointer;
    background-color: var(--theme-accent);
    color: white;
    height: 100%;
    border-radius: 2px;
    display: flex;
    align-items: center;
    transition-property: opacity;
    transition-timing-function: cubic-bezier();
    transition-duration: 150ms;
    flex-shrink: 0;
  }
  .data-bar:hover {
    opacity: 0.75;
  }
  .data-bar-focused {
    opacity: 1;
  }
  .data-bar-not-focused {
    opacity: 0.45;
  }
  .details-section {
    display: flex;
    align-items: center;
    height: 3.5em;
  }
  .data-average-section {
    box-sizing: border-box;
    padding-left: 1em;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .data-average-percent {
    box-sizing: border-box;
    font-size: 1.5em;
  }
  .data-average-percent-negative {
    color: #be6984;
  }
  .data-average-percent-positive {
    color: #68a691;
  }
  .data-average-number {
    color: #4e4e4e;
    font-size: 1.25em;
    width: max-content;
  }
  .data-subsection-labels-wrapper {
    display: flex;
    height: 100%;
    align-items: center;
  }
  .data-subsection-labels {
    display: flex;
    flex-wrap: wrap;
    max-height: 100%;
    width: 11em;
  }
  .data-subsection-label {
    margin-left: 0.25em;
    margin-right: 0.25em;
    vertical-align: middle;
    color: #4e4e4e;
    font-size: 1em;
  }
</style>

<main>
  <div class="data-row">
    <div class="data-label-wrapper">
      <div class="data-label">{dataLabel}</div>
    </div>
    <div class="data-bar-wrapper">
        <div class="data-point">{dataPoint}</div>
          <div
            class="data-bar"
            style={getPercentageStyle(dataPoint, maxValue)}
            on:click={onClick}
            class:data-bar-focused={isFocused}
            class:data-bar-not-focused={!isFocused}>
          </div>
      <div
        class={'details-section'}
        style={`${isFocused ? '' : 'visibility: hidden;'}`}>
        <div class="data-average-section" style={`${averageDeltaPercent !== null && dataPointAverage !== null ? '' : 'visibility: hidden;'}`}>
          <div
            class="data-average-percent"
            class:data-average-percent-positive={averageDeltaPercent >= 0}
            class:data-average-percent-negative={averageDeltaPercent < 0}>
            {averageDeltaPercent >= 0 ? '+' : ''}{averageDeltaPercent}%
          </div>
          <div class="data-average-number">avg {dataPointAverage}</div>
        </div>
        {#if subsectionLabels}
          <div class="data-subsection-labels-wrapper">
            <div class="data-subsection-labels">
              {#each subsectionLabels as label}
                <div class="data-subsection-label">{label}</div>
              {/each}
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</main>
